export const MODEL_TASK_TABLE_ID = "model-tasks-table";
